/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery(document).ready(function(){
 	if(jQuery(".product-block-list__item--description").length > 0){
 		jQuery(".product-block-list__item--description h2.card__title").click(function(){
 			var title_type = jQuery(this).data("title");
 			if(title_type == "product_specs_title"){
 				jQuery(this).closest(".card").find(".product-description-content").hide();
 				jQuery(this).closest(".card").find(".product_specs_content").show();

 				var specs_block = jQuery(this).closest(".card").find(".product_specs_content");
 				var specs_view_txt = specs_block.find(".expandable-content__toggle-text").text();
 				if(specs_view_txt == "View more"){
 					jQuery(this).closest(".card").find(".product_specs_content").attr("aria-expanded", "false");
 				} 				
 			} else {
 				jQuery(this).closest(".card").find(".product-description-content").show();
 				jQuery(this).closest(".card").find(".product_specs_content").hide();
 			}
 		});
 	}
  
  jQuery('.customeClass').click(function() {
    jQuery(".customeClass").removeClass("active");
    jQuery(this).addClass("active");
}); 
 });